exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-player{display:flex;justify-content:center;padding:0 20px}.audio-player .audio-player__controls{margin-top:8px;margin-right:2.3%}", ""]);

// exports
